import Journey from "@/domains/-journey/models/Journey.ts";
import {PersonRoleCoachee} from "@/domains/-workspace/models/PersonRoleCoachee.ts";
import {PersonRoleStaff} from "@/domains/-workspace/models/PersonRoleStaff.ts";
import {Workspace} from "@/domains/-workspace/models/Workspace.ts";
import {GetRoleCoachee, GetRoleStaff, PatchWorkspaceCoachee, PatchWorkspaceStaff, VrPin} from "@/sdk.ts";

export type GetRoleAny = GetRoleCoachee | GetRoleStaff;

function isRoleCoachee(role: GetRoleAny): role is GetRoleCoachee {
  return role.person_role === "coachee";
}

function isRoleCoach(role: GetRoleAny): role is GetRoleStaff {
  return role.person_role === "coach";
}

function isRoleAdmin(role: GetRoleAny): role is GetRoleStaff {
  return role.person_role === "admin";
}

function isRoleExtern(role: GetRoleAny): role is GetRoleStaff {
  return role.person_role === "extern";
}

function extractRoleCoacheeRaw(roles: GetRoleAny[]): GetRoleCoachee | undefined {
  return roles.find(isRoleCoachee);
}

function extractRoleCoach(roles: GetRoleAny[]): PersonRoleStaff | undefined {
  const data: GetRoleStaff | undefined = roles.find(isRoleCoach);
  return data ? new PersonRoleStaff(data) : undefined;
}

function extractRoleAdmin(roles: GetRoleAny[]): PersonRoleStaff | undefined {
  const data: GetRoleStaff | undefined = roles.find(isRoleAdmin);
  return data ? new PersonRoleStaff(data) : undefined;
}

function extractRoleExtern(roles: GetRoleAny[]): PersonRoleStaff | undefined {
  const data: GetRoleStaff | undefined = roles.find(isRoleExtern);
  return data ? new PersonRoleStaff(data) : undefined;
}


export abstract class AbstractWorkspacePerson {
  readonly workspace: Workspace;
  coachee: PersonRoleCoachee | undefined;
  coach: PersonRoleStaff | undefined;
  admin: PersonRoleStaff | undefined;
  extern: PersonRoleStaff | undefined;
  journeys: Journey[];
  vr_pin: VrPin | undefined

  protected constructor(workspace: Workspace, roles: GetRoleAny[]) {
    roles = roles.filter(role => role.workspace_id === workspace.id);
    this.workspace = workspace;
    this.coach = extractRoleCoach(roles);
    this.admin = extractRoleAdmin(roles);
    this.extern = extractRoleExtern(roles);
    const roleCoachee = extractRoleCoacheeRaw(roles);
    this.coachee = roleCoachee ? new PersonRoleCoachee(roleCoachee) : undefined;
    this.journeys = roleCoachee && roleCoachee.journeys ? roleCoachee.journeys.map(data => new Journey(this.workspace.id, data, this.coachee!)) : [];
    this.vr_pin = roleCoachee && roleCoachee.vr_pin ? roleCoachee.vr_pin : undefined;
  }

  update(props: (PatchWorkspaceCoachee.Result & PatchWorkspaceStaff.Result)) {
    if(props.person_roles) {
      const coachee = props.person_roles.find((role): role is GetRoleCoachee => role.person_role === "coachee")
      if(coachee) {
        if(this.coachee === undefined) {
          this.coachee = new PersonRoleCoachee(coachee)
        } else {
          this.coachee.update(coachee);
        }
      }
    }
  }
}